module.exports = __webpack_public_path__ + "img/green1.f5cd8d3e.gif";